import ErrorCodeHelper from '@dealroadshow/error-codes';
import { RpcError } from '@dealroadshow/json-rpc-dispatcher';

/**
 * Retrieves real error from wrapped rpc error
 *
 *
 * @return {*}
 */
const parseWrappedError = () => (response: any) => {
  if (!(response instanceof RpcError)) {
    return response;
  }

  if (response.getCode() === ErrorCodeHelper.getCodeByName('WRAPPED_ERROR') && response.getData().code) {
    response = new RpcError({
      id: response.getId(),
      error: {
        ...response.getData(),
      },
    });
  }

  return response;
};

export default parseWrappedError;
